import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';

type Props = {
  label: string;
  amount: number;
};

const AmountRow: React.FC<Props> = ({ label, amount }) => (
  <JustificationContainer align="center">
    <Body margin={[null]}>{label}</Body>
    <AmountLabel
      align="center"
      justification="center"
      padding={['xxxs', 'xxs']}
      margin={[null, null, null, 'base']}
    >
      <div>{amount}</div>
    </AmountLabel>
  </JustificationContainer>
);

const AmountLabel = styled(JustificationContainer)(
  ({ theme }) => css`
    border-radius: ${theme.getTokens().border.radius.s};
    background-color: ${theme.color('warning')};
    color: ${theme.color('white')};
  `,
);

export default AmountRow;
